export const HTTP_CACHE_HEADERS = {
  NO_CACHE: {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate'
    }
  },
  
  SHORT_CACHE: {
    headers: {
      'Cache-Control': 'max-age=300'
    }
  },
  
  LONG_CACHE: {
    headers: {
      'Cache-Control': 'max-age=3600'
    }
  }
} as const;